import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderMove = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m26.375 27.425-3.75 3.75L24.65 33.2l7.225-7.2-7.225-7.225-2.025 2.025 3.75 3.75h-10.25v2.875zM7.125 39.75q-1.149 0-2.011-.889-.864-.887-.864-1.986v-25.75q0-1.099.864-1.986.862-.89 2.011-.889h14.05l2.875 2.875h16.825q1.099 0 1.986.889.89.887.889 1.986v22.875q0 1.099-.889 1.986-.887.89-1.986.889zm0-2.875h33.75V14H22.85l-2.875-2.875H7.125z" })
});
export default SvgFolderMove;
